import { useId } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { CopyToClipboardButton, generateUrl, paths } from 'shared/base';

interface Props {
  filterId: string;
  onClose: () => void;
  open: boolean;
  teamName: string;
}

export function SavedFiltersPanelShareDialog({ filterId, onClose, open, teamName }: Props) {
  const dialogLabelId = useId();
  const link = generateUrl({
    includeHost: true,
    pathname: paths.platform.team.assetInventory.index,
    query: {
      filterId,
      team: teamName,
    },
  });

  return (
    <Dialog aria-labelledby={dialogLabelId} fullWidth={true} onClose={onClose} open={open}>
      <DialogTitle id={dialogLabelId}>
        <Box alignItems="center" display="flex" justifyContent="space-between">
          <Typography variant="h6">Share filter</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body1">
            Use the following link to share this filter with others:
          </Typography>
          <Box alignItems="center" display="flex" gap={1}>
            <TextField
              aria-readonly={true}
              disabled={true}
              hiddenLabel={true}
              sx={{ flex: '1 1 auto' }}
              value={link}
            />
            <CopyToClipboardButton text={link} />
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} size="medium" variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
